import { useRef } from 'react'
import { useTranslation } from 'react-i18next'
import { OdinIcon } from '@/components/ui/odin/odin-icon'
import { InputGroupButton } from '@/components/ui/input-group'

export type WidgetFileUploadProps = {
  onFilesAdded: (files: File[]) => void
  disable?: boolean
  /** Restricts the native picker to specific types (e.g. bot attachments allow-list). */
  accept?: string
}

export const WidgetFileUpload = ({ onFilesAdded, disable, accept }: WidgetFileUploadProps) => {
  const inputFileRef = useRef<HTMLInputElement>(null)
  const { t } = useTranslation()

  return (
    <>
      <input
        type="file"
        ref={inputFileRef}
        multiple={true}
        accept={accept}
        disabled={disable}
        onChange={(e) => {
          const newFiles = e.target.files
          if (newFiles) {
            onFilesAdded(Array.from(newFiles))
          }
          // Allow re-picking the same file
          e.target.value = ''
        }}
        className="hidden"
      />
      <InputGroupButton
        type="button"
        variant="ghost"
        size="icon-sm"
        aria-label={t('uploadFile')}
        disabled={disable}
        onClick={() => inputFileRef.current?.click()}
      >
        <OdinIcon aria-hidden icon={['far', 'plus']} />
      </InputGroupButton>
    </>
  )
}
